export default (state = [], action) => {
    
    switch (action.type){
        case 'VRP_SOLUTION':
            return action.payload;
        default:
            return [];
    }
};